<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Użytkownicy</span>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja użytkownika:
            <p class="mt-2" style="font-weight: 100">{{data.name + ' ' + data.last_name}}
              <d-badge :theme="data.account_status === 'S_CONFIRMED' ? 'success' : (data.account_status === 'S_BLOCKED' ? 'danger' : 'primary')">
                {{data.account_status === 'S_CONFIRMED' ? 'Zatwierdzony' : (data.account_status === 'S_BLOCKED' ? 'Zablokowany' : 'Nowy') }}
              </d-badge>
            </p>
          </template>
          <template v-else>Dodawanie użytkownika</template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/uzytkownicy')"
        class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          v-if="false"
          theme="info"
          class="mr-1"
          @click.prevent="validateForm(1)">
          Zastosuj zmiany
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm(0)">
          Zapisz i wyjdź
        </d-button>
      </d-col>
    </d-row>
    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab title="Dane ogólne" active>
            <h4 class="mb-3 pb-3 border-bottom">
              Dane ogólne
              <span>
                <d-dropdown
                  v-if="(isEdit && accountData.role !== 'R_HR') || data.role === 'R_ADMIN'"
                  :theme="'light'"
                  class="user-status-dropdown"
                  text="Zmień status użytkownika">
                  <d-dropdown-item>
                    <d-button
                      :theme="'success'"
                      class="accept"
                      @click.prevent="changeStatus('S_CONFIRMED')">
                      Zaakceptowany
                    </d-button>
                  </d-dropdown-item>
                  <d-dropdown-item>
                    <d-button
                      :theme="'danger'"
                      class="blocked"
                      @click.prevent="changeStatus('S_BLOCKED')">
                      Zablokowany
                    </d-button>
                    </d-dropdown-item>
                </d-dropdown>
              </span>
            </h4>
            <validation-observer ref="user-form" tag="form">
              <div class="form-group border-bottom pb-3 mb-3">
                <d-row>
                  <d-col cols="6" md="6" lg="6">
                    <label class="d-block">
                      Rodzaj konta
                    </label>
                    <d-form-radio
                      inline
                      :class="[(importantRole === true && !data.role) ? 'invalid-role-user' : '']"
                      v-model="data.role"
                      value="R_ADMIN">
                      Administrator
                    </d-form-radio >
                    <d-form-radio
                      inline
                      :class="[(importantRole === true && !data.role) ? 'invalid-role-user' : '']"
                      v-model="data.role"
                      value="R_DEPUTY_DIRECTOR">
                      Wicedyrektor
                    </d-form-radio >
                    <d-form-radio
                      inline
                      :class="[(importantRole === true && !data.role) ? 'invalid-role-user' : '']"
                      v-model="data.role"
                      value="R_COORDINATOR">
                      Koordynator
                    </d-form-radio >
                    <d-form-radio
                      inline
                      :class="[(importantRole === true && !data.role) ? 'invalid-role-user' : '']"
                      v-model="data.role"
                      value="R_USER">
                      Użytkownik
                    </d-form-radio >
                    <d-form-radio
                      v-if="!data.is_boss"
                      :class="[(importantRole === true && !data.role) ? 'invalid-role-user' : '']"
                      inline
                      v-model="data.role"
                      value="R_ACCOUNTANT">
                      Główny księgowy
                    </d-form-radio >
                    <d-form-radio
                      v-if="!data.is_boss"
                      :class="[(importantRole === true && !data.role) ? 'invalid-role-user' : '']"
                      inline
                      v-model="data.role"
                      value="R_HR">
                      Kadrowy/a
                    </d-form-radio >
                    <d-form-radio
                      v-if="!data.is_boss"
                      :class="[(importantRole === true && !data.role) ? 'invalid-role-user' : '']"
                      inline
                      v-model="data.role"
                      value="R_RECEPTION">
                      Recepcja
                    </d-form-radio >
                    <div class="invalid-feedback-role-user" style="display: block; margin-top: 0.5rem" v-if="importantRole === true && !data.role">
                      To pole jest wymagane
                    </div>
                  </d-col>
                  <d-col cols="6" md="6" lg="6">
                    <div class="boss-checkbox" v-if="(data.role === 'R_ADMIN') || (data.role === 'R_USER') || (data.role === 'R_DEPUTY_DIRECTOR' || (data.role === 'R_COORDINATOR'))">
                      <d-checkbox inline v-model="data.is_boss" toggle>
                        Jest przełożonym?
                      </d-checkbox>
                    </div>
                  </d-col>
                </d-row>
              </div>
              <div class="form-group" v-if="data.role === 'R_RECEPTION'">
                <d-checkbox inline v-model="data.cancel_holidays" :value="'1'" :checked="String" :unchecked-value="'0'" toggle>
                  Może anulować zaakceptowane urlopy
                </d-checkbox>

                <d-checkbox inline v-model="data.create_holiday_plans" :value="'1'" :checked="String" :unchecked-value="'0'" toggle>
                  Może dodawać plany urlopowe
                </d-checkbox>
              </div>
              <div class="form-group" v-if="data.role === 'R_RECEPTION'">
                <label class="title-box" :for="data.reception_institutions">Wybierz placówkę:</label>
                <multi-select
                  :multiple="true"
                  placeholder="Wybierz..."
                  :options="institutionsData"
                  v-model="data.reception_institutions"
                  :track-by="'id'"
                  label="name"
                  select-label="Wybierz"
                  deselectLabel="Usuń wybór"
                  selectedLabel="Wybrane"
                />
              </div>
              <div class="form-group mb-4">
                <validation-provider
                  :rules="'required'"
                  :name="'employment_type'"
                  v-slot="{ errors }">
                  <div class="form-group">
                    <label class="title-box" :for="data.sign_required">
                      Wystawiane informacje wymagają podpisu dyrektora:
                    </label>
                    <v-select
                      class="reservation-style reservation-style-select-max"
                      placeholder="Wybierz opcję"
                      :options="trueOrFalse"
                      :value="0"
                      :reduce="type => type.id"
                      v-model="data.sign_required"
                      label="name">
                      <template #search="{attributes, events}">
                        <d-input
                          class="input-for-select"
                          :state="errors.length ? 'invalid' : null"
                          :required="!data.sign_required"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.name }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.name }}
                        </div>
                      </template>
                    </v-select>
                  </div>
                  <div class="invalid-feedback" style="display: block; margin-top: -0.5rem;">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group mb-4" v-show="(data.role === 'R_USER' || data.role === 'R_COORDINATOR')">
                <validation-provider
                  :rules="'required'"
                  :name="'employment_type'"
                  v-slot="{ errors }">
                  <div class="form-group">
                    <label class="title-box" :for="data.add_visits">
                      Może dodawać wizyty:
                    </label>
                    <v-select
                      class="reservation-style reservation-style-select-max"
                      placeholder="Wybierz opcję"
                      :options="trueOrFalse"
                      :value="0"
                      :reduce="type => type.id"
                      v-model="data.add_visits"
                      label="name">
                      <template #search="{attributes, events}">
                        <d-input
                          class="input-for-select"
                          :state="errors.length ? 'invalid' : null"
                          :required="!data.add_visits"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.name }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.name }}
                        </div>
                      </template>
                    </v-select>
                  </div>
                  <div class="invalid-feedback" style="display: block; margin-top: -0.5rem;">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <d-row>
                <d-col cols="3" md="3" lg="6">
                  <div class="form-group">
                    <validation-provider
                      :name="'parent_id'"
                      v-slot="{ errors }">
                      <div class="form-group">
                        <label class="title-box" :for="data.parent_id">
                          Przełożony:
                        </label>
                        <v-select
                          class="reservation-style reservation-style-select-low"
                          placeholder="Wybierz przełożonego"
                          :options="bosses"
                          v-model="data.parent_id"
                          :reduce="boss => boss.id"
                          :filterBy="filterByUsers"
                          label="id">
                          <template #search="{attributes, events}">
                            <d-input
                              class="input-for-select"
                              :state="errors.length ? 'invalid' : null"
                              v-bind="attributes"
                              v-on="events"
                            />
                          </template>
                          <template slot="option" slot-scope="option">
                            <div class="d-center">
                              {{ option.name }} {{ option.last_name }}
                            </div>
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                              {{ option.name }} {{ option.last_name }}
                            </div>
                          </template>
                        </v-select>
                      </div>
                      <div class="invalid-feedback" style="display: block; margin-top: -0.5rem;">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col cols="3" md="3" lg="6">
                  <div class="form-group">
                    <validation-provider
                      :rules="'required'"
                      :name="'employment_type'"
                      v-slot="{ errors }">
                      <div class="form-group">
                        <label class="title-box" :for="data.employment_type">
                          Rodzaj pracy:
                        </label>
                        <v-select
                          class="reservation-style reservation-style-select-low"
                          placeholder="Wybierz rodzaj pracy"
                          :options="employmentType"
                          :reduce="type => type.value"
                          v-model="data.employment_type"
                          label="name">
                          <template #search="{attributes, events}">
                            <d-input
                              class="input-for-select"
                              :state="errors.length ? 'invalid' : null"
                              :required="!data.employment_type"
                              v-bind="attributes"
                              v-on="events"
                            />
                          </template>
                          <template slot="option" slot-scope="option">
                            <div class="d-center">
                              {{ option.name }}
                            </div>
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                              {{ option.name }}
                            </div>
                          </template>
                        </v-select>
                      </div>
                      <div class="invalid-feedback" style="display: block; margin-top: -0.5rem;">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col cols="3" md="3" lg="4" v-if="false">
                  <div class="form-group">
                    <validation-provider
                      name="parent_id"
                      v-slot="{ errors }">
                      <label for="hr_id">Kadrowy/a:</label>
                      <div :class="{ 'form-control': true, 'is-select': true }">
                        <v-select
                          :options="HRs"
                          v-model="data.hr_id"
                          :reduce="user => user.id"
                          :filterBy="filterByUsers"
                          placeholder="Wybierz kadrowego/wą"
                          label="id">
                          <template slot="option" slot-scope="option">
                            <div class="d-center">
                              {{ option.name }} {{ option.last_name }}
                            </div>
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                              {{ option.name }} {{ option.last_name }}
                            </div>
                          </template>
                        </v-select>
                      </div>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
              <div class="form-group mt-2">
                <label for="name">
                  Imię:
                </label>

                <validation-provider
                  rules="required"
                  name="name"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group">
                <label for="last_name">
                  Nazwisko:
                </label>

                <validation-provider
                  rules="required"
                  name="last_name"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.last_name"
                   />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group">
                <label for="email">
                  E-mail:
                </label>

                <validation-provider
                  rules="required|email"
                  name="email"
                  v-slot="{ errors }">
                  <d-input
                    autocomplete="off"
                    :state="errors.length ? 'invalid' : null"
                    type="email"
                    v-model="data.email"
                    />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group visit-box" v-if="(data.role === 'R_USER'  || data.role === 'R_COORDINATOR')">
                <label class="title-box" :for="data.procedures">
                  Opis pracownika:
                </label>
                <validation-provider
                  :name="'procedures'"
                  v-slot="{ errors }">
                  <div :class="{ 'form-control': true, 'is-select': true }">
                <textarea
                  :type="'text'"
                  :state="errors.length ? 'invalid' : null"
                  v-model="data.description"
                ></textarea>
                  </div>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <d-row>
                <d-col cols="6" md="6" lg="6">
                  <div class="form-group">
                    <label for="vacation_hours">
                      {{ data.employment_type === 'E_FULL_TIME' ? 'Dni urlopu:' : 'Liczba godzin urlopu'}}
                    </label>
                    <validation-provider
                      rules="required"
                      name="vacation"
                      v-slot="{ errors }">
                      <d-input
                        type="number"
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.vacation_hours" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col cols="6" md="6" lg="6">
                  <div class="form-group">
                    <label for="available_hours">
                      {{ data.employment_type === 'E_FULL_TIME' ? 'Dostępne wolne dni:' : 'Dostępne godzin urlopu'}}
                    </label>
                    <validation-provider
                      rules="required"
                      name="used"
                      v-slot="{ errors }">
                      <d-input
                        type="number"
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.available_hours" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
              <d-row>
                <d-col cols="6" md="6" lg="6">
                  <div class="form-group">
                    <label for="password">
                      Hasło:
                    </label>
                    <validation-provider
                      :rules="isEdit ? 'min:6' : 'required|min:6'"
                      name="password"
                      v-slot="{ errors }">
                      <d-input
                        type="password"
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.password" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col cols="6" md="6" lg="6">
                  <div class="form-group">
                    <label for="passwordConfirmation">
                      Powtórz hasło:
                    </label>

                    <validation-provider
                      :rules="isEdit ? 'min:6|password:password' : 'required|min:6|password:password'"
                      name="password-confirmation"
                      v-slot="{ errors }">
                      <d-input
                        type="password"
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.passwordConfirmation" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
            </validation-observer>

            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>

            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
          <d-tab title="Urlopy pracownika" v-if="isEdit">
            <d-row no-gutters class="page-header py-4">
              <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
                <h3 class="page-title">
                  Lista urlopów
                </h3>
              </d-col>
            </d-row>
            <d-row></d-row>
            <d-row
              v-if="loaded"
              style="width: 100%;"
              class="d-flex ml-0 mb-3 page-filters">
              <validation-observer
                ref="holidays-filters-form"
                tag="form"
                style="width: 100%;"
                class="d-flex">
                <div :class="{ 'form-control': true, 'is-select': true }">
                  <v-select
                    style="width: 100%"
                    class="ml-2"
                    :options="statusFilter"
                    v-model="filtersHolidays.accountStatus"
                    placeholder="Sortuj według statusu"
                    :searchable="false"
                    label="text">
                  </v-select>
                </div>
                <d-button
                  theme="info"
                  outline
                  class="text-nowrap ml-2"
                  @click.prevent="validateFiltersForm">Szukaj</d-button>
                <d-button
                  theme="danger"
                  outline
                  class="text-nowrap ml-2"
                  @click.prevent="clearFilters">Resetuj filtry</d-button>
              </validation-observer>
            </d-row>
            <d-card style="width: 100%; box-shadow: none;">
              <table class="table mt-0 mb-0 full-width">
                <thead class="bg-light">
                <tr>
                  <th scope="col" class="border-0">Rodzaj</th>
                  <th scope="col" class="border-0">Start urlopu</th>
                  <th scope="col" class="border-0">Koniec urlopu</th>
                  <th scope="col" class="border-0">Zgodność z planem urlopowym</th>
                  <th scope="col" class="border-0">Status</th>
                  <th scope="col" class="border-0">Akcje</th>
                </tr>
                </thead>
                <tbody v-if="loaded">
                <tr
                  v-for="(holiday, index) of holidays"
                  :key="'user-' + index"
                  v-if="holiday.user_id === data.id"
                >
                  <td class="align-middle" :style="holiday.type_id === 3 ? (holiday.plan_id > 0 ? '' : (holiday.plan_id === 0 ? 'color: #c4183c' : '')) : ''">
                    {{ holiday.type_name }}
                  </td>
                  <td class="align-middle" style="white-space: nowrap" :style="holiday.type_id === 3 ? (holiday.plan_id > 0 ? '' : (holiday.plan_id === 0 ? 'color: #c4183c' : '')) : ''">
                    {{ holiday.date_start }}
                  </td>
                  <td class="align-middle" style="white-space: nowrap" :style="holiday.type_id === 3 ? (holiday.plan_id > 0 ? '' : (holiday.plan_id === 0 ? 'color: #c4183c' : '')) : ''">
                    {{ holiday.date_end }}
                  </td>
                  <td class="align-middle" :style="holiday.type_id === 3 ? (holiday.plan_id > 0 ? 'color: #17c671;' : (holiday.plan_id === 0 ? 'color: #c4183c' : '')) : ''">
                    {{ holiday.type_id === 3 ? (holiday.plan_id > 0 ? 'TAK' : (holiday.plan_id === 0 ? 'NIE' : '')) : ''}}
                  </td>
                  <td class="align-middle" :style="holiday.status === 'ACCEPTED' ? 'color: #17c671;' : (holiday.status === 'REJECTED' ? 'color: #ad1535;' : (holiday.status === 'NEW' ? '' : 'color: #ffb400;'))">
                    {{ holiday.status === 'NEW' ? 'Oczekuje akceptacji' : ( holiday.status === 'ACCEPTED' ? 'Zaakceptowany' : ( holiday.status === 'REJECTED' ? 'Odrzucony' : 'Anulowany')) }}
                  </td>
                  <td class="align-middle" style="width: 220px;">
                    <d-dropdown
                      class="dropdownStatus"
                      v-if="(holiday.status !== 'CANCELED') && (userData.role !== 'R_HR')"
                      style="width: 30%"
                      :theme=" holiday.status === 'NEW' ? 'secondary' : ( holiday.status === 'ACCEPTED' ? 'success' : ( holiday.status === 'REJECTED' ? 'danger' : 'warning'))"
                      :menu-id="`dropdown-${holiday.id}`"
                      :text="holiday.status !== 'ACCEPTED' && holiday.status !== 'REJECTED' ?
              (holiday.status === 'NEW' ? 'Dodaj status' : 'Anulowany') : (holiday.status === 'ACCEPTED' ? 'Zaakceptowany' : 'Odrzucony')">
                      <d-dropdown-item>
                        <d-button
                          :disabled="holiday.status !== 'NEW'"
                          style="width: 100%"
                          theme="success"
                          :menu-id="`dropdown-accepted-${holiday.id}`"
                          @click="handleAccepted(holiday.id)">
                          Zaakceptuj
                        </d-button>
                      </d-dropdown-item>
                      <d-dropdown-item>
                        <d-button
                          :disabled="holiday.status !== 'NEW'"
                          style="width: 100%"
                          theme="danger"
                          :menu-id="`dropdown-rejected-${holiday.id}`"
                          @click="handleRejected(holiday.id)">
                          Odrzuć
                        </d-button>
                      </d-dropdown-item>
                    </d-dropdown>
                    <d-button
                      theme="info"
                      @click.prevent="$router.push({path: '/urlopy-pracownikow/edycja/' + holiday.id, query: { back: 'userItem' } })"
                      class="ml-2"
                      title="Szczegóły urlopu">
                      <i class="material-icons">person_search</i>
                    </d-button>
                  </td>
                  <d-modal
                    v-if="showAccepted || showRejected">
                    <d-modal-header>
                      <d-modal-title class="mt-3 mb-3">
                        {{showAccepted ? 'Potwierdzasz akceptację urlopu ?' : 'Potwierdzasz odrzucenie urlopu ?'}}
                      </d-modal-title>
                    </d-modal-header>
                    <d-modal-body>
                      <div class="form-group">
                        <label for="boss_description">
                          Dodaj adnotacje:
                        </label>
                        <validation-provider
                          name="description"
                          v-slot="{ errors }">
                          <d-form-textarea
                            :state="errors.length ? 'invalid' : null"
                            v-model="dataHolidays.boss_description" />
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </validation-provider>
                      </div>
                      <div class="popup-box-buttons">
                        <d-button
                          theme="success"
                          class="text-nowrap"
                          @click.prevent="submitHolidaysForm(dataHolidays.id, (showAccepted ? 'ACCEPTED' : 'REJECTED'))">
                          Potwierdź
                        </d-button>
                        <d-button
                          theme="secondary"
                          class="text-nowrap ml-3"
                          @click.prevent="handleClose">
                          Anuluj
                        </d-button>
                      </div>
                    </d-modal-body>
                  </d-modal>
                </tr>
                <tr v-for="(holiday, index) of holidays"
                    :key="'error-' + index"
                    v-if="holidays.length !== 0 && holiday.user_id !== data.id">
                  <td
                    v-if="index === 1"
                    colspan="6"
                    class="text-center">
                    Brak urlopów do wyświetlenia&hellip;
                  </td>
                </tr>
                <tr v-if="holidays.length === 0">
                  <td
                    colspan="6"
                    class="text-center">
                    Brak urlopów do wyświetlenia&hellip;
                  </td>
                </tr>
                </tbody>
              </table>
              <div v-if="!loaded" class="pb-3 pt-3 text-center">
                Trwa ładowanie danych&hellip;
              </div>
              <d-alert
                v-if="loadError"
                show
                theme="warning">
                Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
              </d-alert>
            </d-card>
            <pagination :visible-position="false" :meta-data="paginationMetaData" />
          </d-tab>
          <d-tab title="Kategorie i usługi" v-if="isEdit" :disabled="(data.role !== 'R_USER') && (data.role !== 'R_COORDINATOR')">
            <h4 class="mb-3 pb-3 border-bottom">
              Kategorie i usługi
            </h4>
            <validation-observer ref="user-form" tag="form">
              <div class="form-group">
              <div
                class="form-group"
                v-for="(category, index) in categoriesData"
                :key="index">
                    <label class="mb-3 mt-3 font-weight-bold">
                      {{ category.name }}
                    </label>
                  <div
                    v-for="(service, index) in category.services"
                    :key="index">
                    <d-checkbox
                      :checked="servicesId.includes(service.id)"
                      :value="service.id"
                      v-model="servicesId"
                      :class="'mb-3'"
                      toggle>
                      {{service.name}}
                    </d-checkbox>
                  </div>
                </div>
              </div>
            </validation-observer>

            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>

            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
          <d-tab title="Instytucje i gabinety" v-if="isEdit" :disabled="(data.role !== 'R_USER') && (data.role !== 'R_COORDINATOR')">
            <h4 class="mb-3 pb-3 border-bottom">
              Instytucje i gabinety
            </h4>
            <validation-observer ref="user-form" tag="form">
              <div class="form-group">
                <days-and-hours
                  v-if="data.id"
                  :user-id="data.id"
                  :refresh="refreshTimetable"
                  :load-items="schedules"
                  :save="saveDaysAndHours"/>
              </div>
            </validation-observer>

            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>

            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import ListUtils from './../../utils/ListUtils.js';
import debounce from 'lodash.debounce';
import daysAndHours from '../others/DaysAndHours';
import HasPagination from './../../mixins/HasPagination.vue';
import Pagination from './../../components/common/Pagination.vue';
import HasFilters from './../../mixins/HasFilters.vue';
import multiSelect from 'vue-multiselect'

export default {
  name: 'user-form',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination,
    daysAndHours,
    multiSelect
  },
  watch: {
    'servicesId': function (value) {
      if (value) {
        this.comparisonServicesId();
      }
    },
    'servicesData': function (value) {
      if (value) {
        this.comparisonServicesId();
      }
    },
    'data.cancel_holidays': function (to) {
      this.data.cancel_holidays = to.toString();
    },
    'data.create_holiday_plans': function (to) {
      this.data.create_holiday_plans = to.toString();
    }
  },
  computed: {
    allDataLoaded () {
      return this.loaded && this.loadedUsers;
    },
    isEdit () {
      return !!this.$route.params.id;
    },
    userData () {
      return this.$store.getters.getUserForm
    },
    accountData () {
      return this.$store.getters.getAccount
    },
    employmentType () {
      return [
        {
          name: 'Pełen etat',
          value: 'E_FULL_TIME'
        },
        {
          name: 'Niepełny etat',
          value: 'E_PART_TIME'
        },
      ];
    },
    trueOrFalse () {
      return [
        {
          name: 'Tak',
          id: 1
        },
        {
          name: 'Nie',
          id: 0
        },
      ];
    },
    statusFilter () {
      return [
        {
          text: 'Zaakceptowane',
          value: 'ACCEPTED'
        },
        {
          text: 'Odrzucone',
          value: 'REJECTED'
        },
        {
          text: 'Anulowane',
          value: 'CANCELLED'
        },
        {
          text: 'Oczekuje akceptacji',
          value: 'NEW'
        }
      ];
    },
  },
  data() {
    return {
      data: {
        id: null,
        name: '',
        last_name: '',
        email: '',
        role: '',
        is_boss: false,
        add_visits: 0,
        sign_required: null,
        hr_id: null,
        reception_institutions: [],
        password: '',
        passwordConfirmation: '',
        vacation_hours: 0,
        available_hours: '',
        offices: [],
        services: [],
        description: '',
        employment_type: '',
        account_status: 'S_NEW',
        offices_work_hours: [],
      },
      dataHolidays: {
        status: '',
        id: '',
        boss_description: ''
      },
      loaded: false,
      loadError: false,
      users: [],
      holidays: [],
      showAccepted: false,
      showRejected: false,
      HRs: [],
      schedules: [],
      bosses: [],
      categoriesData: [],
      servicesData: [],
      officesData: [],
      institutionsData: [],
      servicesId: [],
      servicesArr: [],
      loadedUsers: false,
      importantRole: false,
      saveDaysAndHours: false,
      startModule: 1,
      filter: {
        role: 'R_HR',
      },
      filtersHolidays: {
        user_id: '',
        accountStatus: ''
      }
    };
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
      this.getUser();
    } else {
      this.loaded = true;
      this.getUser();
    }
    this.loadAdditionalData();
    this.loadBossListData();
    this.getServicesList();
    this.getCategoriesList();
    this.getOfficesList();
    this.getInstitutionsList();
    this.loadSchedulesUsersItems();
    this.loadHRsList();
    this.getAccount();
    setTimeout(() => {
      this.dataServicesId();
      this.filterId();
      if (this.data.role !== 'R_USER') {
        this.loadSchedulesUsersItems();
      }
    }, 1000);
    setTimeout(() => {
      this.loadFilteredHolidaysData();
    }, 200);
  },
  methods: {
    getAccount () {
      this.$store.dispatch('userAccountGet')
    },
    dataServicesId () {
      const data = this.data.services;
      let servicesId = [];
      for (let i = 0; i < data.length; i++) {
        servicesId[i] = data[i].id
      }
      this.servicesId = servicesId;
    },
    comparisonServicesId () {
      if (this.servicesData && this.servicesId) {
        const services = this.servicesData;
        const checkId = this.servicesId;
        let checkboxArr = [];
        for (let i = 0; i < services.length; i++) {
          for (let j = 0; j < checkId.length; j++) {
            if (checkId[j] === services[i].id) {
              checkboxArr[i] = services[i]
            }
          }
        }
        this.servicesArr = checkboxArr;
      }
    },
    filterId() {
      this.filtersHolidays.user_id = this.data.id
    },
    handleClose() {
      this.showAccepted = false;
      this.showRejected = false;
    },
    changeStatus(value) {
      this.data.account_status = value
    },
    handleAccepted(id) {
      this.showAccepted = true;
      this.dataHolidays.id = id
    },
    handleRejected(id) {
      this.showRejected = true;
      this.dataHolidays.id = id
    },
    getUser () {
      this.$store.dispatch('userFormGet', this.id)
    },
    loadHRsList () {
      let where = {
        role: this.filter.role
      };
      FormUtils.loadAdditionalData(this, {
        endpoint: '/users/items',
        outputKey: 'HRs',
        params: {
          where
        },
      });
    },
    refreshTimetable () {
      this.getOfficesList();
      this.getInstitutionsList();
      this.loadAdditionalData();
      this.loadSchedulesUsersItems();
    },
    getOfficesList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/offices/items',
        outputKey: 'officesData',
        params: {
          pagination: false
        },
      });
    },
    getInstitutionsList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/institutions/items',
        outputKey: 'institutionsData',
        params: {
          pagination: false
        },
      });
    },
    getCategoriesList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: 'services/categories/items',
        outputKey: 'categoriesData',
        params: {
          pagination: false
        },
      });
    },
    loadSchedulesUsersItems () {
      this.$http.post('/schedules/users/all', {
        user_id: this.$route.params.id,
      }).then((response) => {
        this.schedules = response.data.data
      }).catch((error) => {
        console.log(error);
      });
    },
    getServicesList () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/services/items?ignore_users_filters=1',
        outputKey: 'servicesData',
        params: {
          pagination: false
        },
      });
    },
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/users/item/',
        instanceFields: ['id', 'name', 'last_name', 'email', 'is_boss', 'role', 'parent_id', 'vacation_hours', 'available_hours', 'offices', 'services', 'hr_id', 'employment_type', 'offices_work_hours', 'reception_institutions', 'account_status', 'description', 'add_visits', 'sign_required', 'cancel_holidays', 'create_holiday_plans'],
        booleanFields: ['is_boss'],
        loadedKey: 'loaded'
      });
    },
    loadBossListData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/users/bosses',
        outputKey: 'bosses',
        loadedKey: 'loadedUsers',
        errorKey: 'loadError',
      });
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/users/items',
        params: {
          pagination: false
        },
        outputKey: 'users',
        loadedKey: 'loadedUsers',
        errorKey: 'loadError',
      });
    },
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredHolidaysData();
    }, 250),
    loadFilteredHolidaysData () {
      let where = {
        user_id: this.$route.params.id,
      };
      if (this.filtersHolidays.accountStatus !== null && this.filtersHolidays.accountStatus && this.filtersHolidays.accountStatus.value) {
        where.status = this.filtersHolidays.accountStatus.value;
      }
      ListUtils.loadItemsData(this, {
        endpoint: 'holidays/items?page=' + this.currentPage,
        listField: 'holidays',
        pagination: true,
        params: {
          where
        }
      });
    },
    clearFilters () {
      this.loaded = false;
      this.loadError = false;
      this.filtersHolidays = {
        user_id: '',
        accountStatus: ''
      };

      this.loadFilteredHolidaysData();
      this.$bus.$emit('view-filters-reset');
    },
    validateFiltersForm () {
      this.$bus.$emit('pagination-reset');
      FormUtils.validate(this.$refs['holidays-filters-form'], this.debouncedLoadFilteredData);
    },
    validateForm (number) {
      this.importantRole = true;
      this.saveDaysAndHours = true;
      if (this.data.role) {
        FormUtils.validate(this.$refs['user-form'], () => this.submitForm(number));
      } else {
        FormUtils.validate(this.$refs['user-form']);
      }
    },
    submitForm (value) {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = this.isEdit ? '/users/update/' + this.id : '/users/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano użytkownika',
        successText: 'Wybrany użytkownik został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja użytkownika nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          if (value === 0) {
            this.$router.push('/uzytkownicy');
          } else {
            if (this.isEdit) {
              this.loadItemData();
              this.getUser();
            } else {
              this.loaded = true;
              this.getUser();
            }
            this.loadAdditionalData();
            this.loadBossListData();
            this.getServicesList();
            this.getCategoriesList();
            this.getOfficesList();
            this.getInstitutionsList();
            this.loadHRsList();
            setTimeout(() => {
              this.dataServicesId();
              this.filterId();
            }, 500);
            setTimeout(() => {
              this.loadFilteredHolidaysData();
              this.comparisonServicesId();
              this.dataServicesId();
            }, 1000);
          }
        }
      });
    },
    submitHolidaysForm (holidayID, statusOption) {
      let formDataToSend = {
        status: statusOption,
        boss_description: this.dataHolidays.boss_description
      };
      let endpointUrl = '/holidays/update-status/' + holidayID;
      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano urlop pracownika',
        successText: 'Urlop pracownika został zaktualizowany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja urlopu nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          this.showAccepted = false;
          this.showRejected = false;
          this.loadFilteredHolidaysData();
        }
      })
    },
    prepareFormDataToSend () {
      let formDataToSend = {
        name: this.data.name,
        last_name: this.data.last_name,
        email: this.data.email,
        description: this.data.description,
        account_status: this.data.account_status,
        add_visits: this.data.add_visits,
        sign_required: this.data.sign_required,
        role: this.data.role,
        is_boss: this.data.role !== 'R_RECEPTION' && this.data.role !== 'R_HR' ? this.data.is_boss : false,
        parent_id: this.data.parent_id,
        reception_institutions: this.data.reception_institutions,
        offices: this.data.offices,
        services: this.servicesArr.length ? this.servicesArr.filter(n => n) : [],
        available_hours: this.data.available_hours,
        used_days: this.data.used_days,
        vacation_hours: this.data.vacation_hours,
        hr_id: this.data.hr_id,
        employment_type: this.data.employment_type,
        cancel_holidays: this.data.cancel_holidays,
        create_holiday_plans: this.data.create_holiday_plans,
        offices_work_hours: this.data.role !== 'R_RECEPTION' ? this.data.offices_work_hours : []
      };
      if (this.data.password !== '' && this.data.passwordConfirmation !== '') {
        formDataToSend.password = this.data.password;
        formDataToSend.password_confirmation = this.data.passwordConfirmation;
      }

      return formDataToSend;
    },
    filterByUsers (option, label, search) {
      return (option.name + ' ' + option.last_name).toLowerCase().indexOf(search.toLowerCase()) > -1;
    }
  }
};
</script>
<style lang="scss" scoped>
  @import '../../assets/scss/variables/mixins.scss';
  .popup-box-buttons {
    @include popupButtons
  }
  .modal-dialog {
    margin-top: 20vw !important;
  }
  .page-title {
    p {
      display: flex;
      span {
        margin-left: 1rem;
      }
    }
  }
  .user-status-dropdown {
    margin-left: 2rem;
    border-radius: 20px;
    .dropdown-toggle {
      padding: 0.5rem 1.7rem;
    }
    .accept, .blocked {
      min-width: 8rem !important;
    }
  }
  .boss-checkbox {
    margin-top: 1.5rem;
    text-align: end;
  }
  .invalid-role-user {
    outline: none;
    color: #c4183c;
  }
  .invalid-feedback-role-user {
    margin-top: -0.65rem;
    font-size: 80%;
    color: #c4183c;
  }
  .vs__dropdown-option {
    white-space: normal;
  }
</style>
